
import { createContext, useReducer } from "react";
import MovementReducer from "./MovementReducer";

const INITIAL_STATE = {
  movements: [],
  count: 1,
  isFetching: false,
  error: false,
  movement: {},
  isFetchingAdd: false,
  errorAdd: false,
  isFetchingUpdate: false,
  errorUpdate: false,
  envoisMovement: [],
  countGlobal: 1,
  sumMontant: 0,
  isFetchingLoad: false,
  errorLoad: false,
  message: "",
  isFetchingSubmit: false,
  errorSubmit: false,
  isFetchingRetourAutreSubmit: false,
  errorRetourAutreSubmit: false,
  movementDecharge: {},
  envoisDecharge: [],
  isFetchingGetDecharge: false,
  errorGetDecharge: false,
  movementEncaissement: {},
  envoisEncaissement: [],
  isFetchingGetEncaissement: false,
  errorGetEncaissement: false,
};


export const MovementContext = createContext(INITIAL_STATE);

export const MovementContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(MovementReducer, INITIAL_STATE);

  return (
    <MovementContext.Provider
      value={{
        movements: state.movements,
        count: state.count,
        isFetching: state.isFetching,
        error: state.error,
        movement: state.movement,
        isFetchingAdd: state.isFetchingAdd,
        errorAdd: state.errorAdd,
        isFetchingUpdate: state.isFetchingUpdate,
        errorUpdate: state.errorUpdate,
        envoisMovement: state.envoisMovement,
        countGlobal: state.countGlobal,
        sumMontant: state.sumMontant,
        isFetchingLoad: state.isFetchingLoad,
        errorLoad: state.errorLoad,
        message: state.message,
        isFetchingSubmit: state.isFetchingSubmit,
        errorSubmit: state.errorSubmit,
        isFetchingRetourAutreSubmit: state.isFetchingRetourAutreSubmit,
        errorRetourAutreSubmit: state.errorRetourAutreSubmit,
        movementDecharge: state.movementDecharge,
        envoisDecharge: state.envoisDecharge,
        isFetchingGetDecharge: state.isFetchingGetDecharge,
        errorGetDecharge: state.errorGetDecharge,
        movementEncaissement: state.movementEncaissement,
        envoisEncaissement: state.envoisEncaissement,
        isFetchingGetEncaissement: state.isFetchingGetEncaissement,
        errorGetEncaissement: state.errorGetEncaissement,
        dispatch,
      }}
    >
      {children}
    </MovementContext.Provider>
  );
};